import type { NavSectionProps } from 'src/components/nav-section';

import { useQuery } from '@tanstack/react-query';

import API from 'src/services/API';
import { useSelectedTenant } from 'src/layouts/provider';

import { menusToNavData } from '../utils/menu-to-nav-data';

// ----------------------------------------------------------------------

type NavScope = 'dashboard' | 'hq';

/** 拉取当前用户在当前租户下可见的导航菜单 */
export function useMeNavData(scope?: NavScope): NavSectionProps['data'] {
  const { tenantId, loading: tenantLoading } = useSelectedTenant();

  const { data, isLoading } = useQuery({
    queryKey: ['me', 'menus', scope, tenantId],
    queryFn: async () => {
      const res = await API.MeMenu.MeMenuControllerGetMyMenusV1({ scope: scope! });
      return menusToNavData(res.data?.data ?? []);
    },
    enabled: !!scope && !!tenantId && !tenantLoading,
  });

  if (!scope || tenantLoading || isLoading) {
    return [];
  }

  return data ?? [];
}
